var map = {
	"./cloud.png": 4762,
	"./discomfort.png": 1209,
	"./discomfortR.png": 9759,
	"./humidity.png": 1186,
	"./humidityR.png": 6570,
	"./little_cloud.png": 2711,
	"./lots_cloud.png": 2799,
	"./rain.png": 7471,
	"./snow.png": 3592,
	"./snow_rain.png": 5579,
	"./sunny.png": 3504,
	"./wind_direction.png": 9017,
	"./wind_directionR.png": 1839,
	"./wind_speed.png": 8647,
	"./wind_speedR.png": 9605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7066;